module.exports = __webpack_public_path__ + "assets/e208c95eaee543a1a8300356d8f84220.mp4";